import React, { FocusEvent, useState, ChangeEvent } from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { Field as FormikField } from 'formik';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, StyledInput } from './styles';

interface Props {
  label?: string;
  name?: string;
  isMultiline?: boolean;
  options: string[];
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onSelect?: (event: React.SyntheticEvent<HTMLDivElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Field = ({ label, name, isMultiline, onFocus, options, onSelect, onChange }: Props) => {
  const { t } = useStoreTranslation();
  const [isTouched, setIsTouched] = useState(false);
  return (
    <Container>
      <FormikField name={name}>
        {({ field, form }: any) => {
          const error = form && form.errors[field.name] ? t(String(form.errors[field.name])) : undefined;
          const hasTouched = form ? Boolean(form.touched[field.name]) : false;
          setIsTouched(hasTouched);
          return (
            <Autocomplete
              freeSolo
              {...field}
              options={options}
              disableClearable
              onSelect={onSelect}
              renderInput={(params) => (
                <StyledInput
                  {...params}
                  label={label}
                  error={!!error && isTouched}
                  helperText={!!error && isTouched ? error : ''}
                  multiline={isMultiline}
                  onFocus={onFocus}
                  onChange={onChange}
                />
              )}
            />
          );
        }}
      </FormikField>
    </Container>
  );
};

export default Field;
